import { ChartConfiguration, ScaleOptions } from 'chart.js'
import embeddedPriceOptions from './embeddedPriceOptions'

const mainData = {
	yAxe: {
		position: 'left',
		display: true,
		stacked: true,
		yAxisID: 'y1',

		ticks: {
			beginAtZero: true,
			// min: 1.5,
			suggestedMax: 2,
			color: '#19B338',
		},
		gridLines: {
			offsetGridLines: false,
		},
	} as ScaleOptions,
	xAxe: {
		stacked: true,
		gridLines: {
			display: false,
		},
		grid: {
			display: false,
		},
		// type: 'time',
		ticks: {
			autoSkip: true,
			maxTicksLimit: 10,
		},
	},
}

export const datasetDefaults = {
	borderRadius: 2,
}

export default {
	type: 'bar',
	responsive: true,
	data: {
		labels: [],
		datasets: [embeddedPriceOptions.dataset],
	},
	defaults: {},
	options: {
		aspectRatio: 1.4,
		scales: {
			y: embeddedPriceOptions.yAxes,
			y1: mainData.yAxe,
			x: mainData.xAxe,
		},
		plugins: {
			tooltip: {
				titleFont: {
					size: 14,
					weight: 'bold',
				},
				bodyFont: {
					size: 12,
				},
			},
			legend: {
				display: true,
				reverse: true,
				labels: {
					filter: (item: any) =>
						!item?.text?.includes('undefined') &&
						!item?.text?.includes('sis.') &&
						!item?.text?.includes('Kalliit'),
				},
			},
		},
	},
} as ChartConfiguration

export const initialConsumptionElementsChartOptions = {
	type: 'bar',
	responsive: true,
	data: {
		labels: [],
		datasets: [],
	},
	defaults: {},
	options: {
		aspectRatio: 1.8,
		scales: {
			y: mainData.yAxe,
			x: mainData.xAxe,
		},
		plugins: {
			tooltip: {
				titleFont: {
					size: 14,
					weight: 'bold',
				},
				bodyFont: {
					size: 12,
				},
			},
			legend: {
				display: true,
				reverse: true,
				labels: {
					filter: (item: any) => !item?.text?.includes('undefined'),
				},
			},
		},
	},
} as ChartConfiguration
